<template>
  <div class = "paginaDedicata">
    <NormalHeader :data="header"/>
    <img :src="logo" class = "imagine">
    <h1 class = "title">{{$t(title)}}</h1>
    <h2 class = "subtitle">{{$t(subtitle)}}</h2>
    <p v-html="$t(text1)" class = "text"></p>
    <ul type="disc">
      <li v-html="$t(bullet1)"></li>
      <li v-html="$t(bullet2)"></li>
    </ul>  
    <p v-html="$t(text2)" class = "text"></p>
    <ul>
      <li v-html="$t(bullet3)"></li>
      <li v-html="$t(bullet4)"></li>
    </ul>
    <p v-html="$t(text3)" class = "text"></p>
    <ul>
      <li v-html="$t(bullet5)"></li>
      <li v-html="$t(bullet6)"></li>
      <li v-html="$t(bullet7)"></li>
      <li v-html="$t(bullet8)"></li>
    </ul>
    <p v-html="$t(text4)" class = "text"></p>
    <a href ="https://stagiipebune.ro/companii/bitdefender/?fbclid=IwAR29ghVPLiEVib3DlUOYq0ZZB557vmPZ_andaucJ0AFFt8Mq_2oISklJSqI">https://stagiipebune.ro/companii/bitdefender/</a>
  </div> 
</template>

<script>
import NormalHeader from '@/components/global-components/NormalHeader'
export default {
  components:{
    NormalHeader
  },
  data() {
    return {
      header: {
        transparent: false
      },
      logo : "https://i.imgur.com/LQyxL9R.png",
      title: "dedicate.bitdefender.title",
      subtitle: "dedicate.bitdefender.subtitle",
      text1: "dedicate.bitdefender.text1",
      text2: "dedicate.bitdefender.text2",
      text3: "dedicate.bitdefender.text3",
      text4: "dedicate.bitdefender.text4",
      bullet1: "dedicate.bitdefender.bullet1",
      bullet2: "dedicate.bitdefender.bullet2",
      bullet3: "dedicate.bitdefender.bullet3",
      bullet4: "dedicate.bitdefender.bullet4",
      bullet5: "dedicate.bitdefender.bullet5",
      bullet6: "dedicate.bitdefender.bullet6",
      bullet7: "dedicate.bitdefender.bullet7",
      bullet8: "dedicate.bitdefender.bullet8",
      header: {
        transparent: false
      }
    }
  }
} 
</script>

<style scoped lang="scss">
.imagine {
  margin-top: 5%!important;
  margin-bottom: 6%!important;
  padding-top: 0px;
  height: 15vh;
  display: block;
  margin: auto;
}

.title {
  margin-bottom: 3%;
  font-size: 35px!important;
}

.text {
  text-align: center;
  margin-left: 2%;
  margin-right: 2%;
  margin-bottom: 2%;
  margin-top: 2%;
  font-size: 20px!important;
}

.subtitle {
   font-size: 30px!important;
}

.paginaDedicata {
  color: $primary-color !important;
}
ul { 
  display: block;
  list-style-type: disc;
  color: black;
}
li{
  margin-bottom: 3px!important;
  text-align: center;
  font-size: 20px!important;
  margin-left: 2%;
  margin-right: 2%;
}

a{
  text-align: center;
  color: black;
  font-size: 20px!important;
  display: block;
  margin-bottom: 5px;
}

@media screen and (max-width: 600px) {
  .imagine {
    height: 9vh;
  }
  .subtitle {
   margin-top: 7%!important;
  }
  .title {
    margin-top: 7%!important;
  }
}

</style>